/**
 * All your custom scripts should be here
 */

$('.dropdown > a').click(function () {
    let parentBlock = $(this).parent('.dropdown');

    if (parentBlock.hasClass('active')) {
        parentBlock.removeClass('active');
    } else {
        if (!$('.navbar').hasClass('ready-auth')) {
            $('.dropdown').removeClass('active');
        }
        $('.navbar-nav--right .dropdown').removeClass('active');
        parentBlock.addClass('active');
    }
});

$('.sidebar-mob-toggle').click(function () {
    $('.body').addClass('_open-mobile-menu');
    $('.sidebar').addClass('_open');
    $('.overlay').addClass('_show');
});

$('.close-sidebar').click(function () {
    $('.body').removeClass('_open-mobile-menu');
    $('.sidebar').removeClass('_open');
    $('.overlay').removeClass('_show');
});

$('.overlay').click(function () {
    $('.body').removeClass('_open-mobile-menu');
    $('.sidebar').removeClass('_open');
    $('.overlay').removeClass('_show');
    $('.navbar-nav--right').removeClass('_open');
});

$('.navbar-toggler').click(function () {
    if ($('.navbar-nav--right').hasClass('_open')) {
        $('.navbar-nav--right').removeClass('_open');
        if (!$('.navbar').hasClass('ready-auth')) {
            $('.overlay').removeClass('_show');
        }
    } else {
        $('.navbar-nav--right').addClass('_open');
        if (!$('.navbar').hasClass('ready-auth')) {
            $('.overlay').addClass('_show');
        }
    }
});

$('.close-menu-mob').click(function () {
    $('.navbar-nav--right').removeClass('_open');
    $('.overlay').removeClass('_show');
});

$(document).mouseup(function (e) {
    // var container = $(".navbar-toggler");
    var container = $('.dropdown');
    if (container.has(e.target).length === 0) {
        if (!$('.navbar').hasClass('ready-auth')) {
            $('.dropdown-menu, .dropdown').removeClass('active');
        } else {
            $('.navbar-nav--right').removeClass('_open');
        }
        $('.navbar-nav--right .dropdown').removeClass('active');
    }
});

$(function () {
    $('[data-toggle="tooltip"]').tooltip()
})

import { EventBus } from '../event-bus.js';

if (window.popUpMessage) {
    EventBus.$emit('event-popup-info', window.popUpMessage);
}


// WEBPACK FOOTER //
// ./resources/assets/js/custom-scripts/index.js